import { Button, Modal } from 'antd';
import styled from 'styled-components';

export const Container = styled.section`
  font-family: 'Work Sans', Arial, Helvetica, sans-serif;

  & > header {
    padding: 1.5rem;
    background-color: ${({ theme }) => theme.colors.white};

    & > div {
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};
      }
    }

    & > .title {
      font-weight: 700;
      margin-bottom: 1.125rem;
      font-size: 1.625rem;
    }

    & > span {
      font-size: 1rem;
    }
  }

  & .cards {
    width: 100%;
    padding: 1.5rem 0;
    background-color: #efefef;

    & .cards-container {
      display: flex;
      flex-wrap: wrap;
      row-gap: 1.5rem;
      column-gap: 1.5rem;
      width: 97%;
      margin: 1rem auto 1rem auto;

      & > .card {
        width: 100%;
      }

      p {
        min-height: 75px;
      }

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        justify-content: space-between;
        flex-wrap: nowrap;
        column-gap: 1.5rem;

        & > .card {
          width: 50%;
          .hefesto-card-text-buttons > span {
            height: 3rem;
          }
        }
      }
    }
  }
`;

export const SteelTypeCard = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  min-height: 15rem;
  padding: 1rem;
  border-radius: 6px;
  box-shadow: ${({ theme }) => theme.commoms.boxShadow};
  border: 1.5px solid ${({ theme }) => theme.colors.gray6};
  margin-bottom: 1.5rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 22.75rem;

    &:first-child {
      margin-right: 1.5rem;
    }
  }

  & > header {
    & > h3 {
      font-size: 1.25rem;
      font-weight: 600;
      color: ${({ theme }) => theme.colors.blue};
    }

    & > span {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.grayDark2};
    }
  }
`;

export const OrderInProgressAlert = styled.span`
  /* display: flex;*/
  align-items: center;
  color: ${({ theme }) => theme.colors.purple2};
  margin: 0.25rem 0;
  height: 1rem;

  & > span svg {
    height: 1rem;
    width: 2rem;
  }
`;

export const SteelTypeChooseButton = styled(Button)`
  width: 100%;
  height: 3.125rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.grayDark2};

  &:hover {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.blue};
  }
`;

export const OrderInProgressModal = styled(Modal)`
  & .ant-modal-header {
    border-bottom: none;

    & > div {
      font-size: 1.25rem;
      color: ${({ theme }) => theme.colors.grayDark2};
    }
  }

  & .ant-modal-body {
    padding: 0 1.5rem 0.5rem;
    & > span {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.grayDark2};
    }
  }

  & .ant-modal-footer {
    border-top: none;
  }
`;
